<template>
  <section>
    <v-row class="d-flex justify-content-center" no-gutters>
      <v-col col sm="12" md="12" lg="12">
        <v-stepper v-model="currentStep">
          <div class="white--text d-flex justify-space-between color pa-2">
            <div>
              <span class="text-h6 ms-2 mt-2">{{ $t("addBeneficiary") }}</span>
            </div>
            <div>
              <v-btn fab small color="white" @click="closeBusDialog">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <v-stepper-header>
            <v-stepper-step :complete="currentStep > 1" step="1">
              Company Information</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" step="2">
              {{ $t("account_details_beneficary") }}</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 3" step="3">
              Summary</v-stepper-step
            >
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <company-details
                :isTrans="isTrans"
                :beneficiaryReqBody="beneficiaryReqBody"
                :BusrecieverData="beneficiarybusData"
                @onClickNext="onClickNext"
                @onClickBack="onClickBack"
                @onCountrySelect="selctedCountry"
              />
            </v-stepper-content>
            <v-stepper-content step="2">
              <account-section
                :isTrans="isTrans"
                :beneficiaryReqBody="beneficiaryReqBody"
                :BusrecieverData="beneficiarybusData"
                :loader="loader"
                :country_code="beneficiaryReqBody.country_code"
                @onClickNext="onClickNext"
                @onClickBack="onClickBack"
              ></account-section>
            </v-stepper-content>
            <v-stepper-content step="3">
              <Summary
                :isTrans="isTrans"
                :beneficiaryReqBody="beneficiaryReqBody"
                @onClickNext="onCreateBeneficiary"
                @onClickBack="onClickBack"
              ></Summary>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import CompanyDetails from "@/components/BeneficiaryBus/CompanyDetails/index.vue";
import AccountSection from "@/components/BeneficiaryBus/AccountSection/index.vue";
import Summary from "@/components/BeneficiaryBus/Summary/index.vue";
import remmitenceService from "@/services/RemitteService/remitteService.js";
export default {
  mixins: [alerts],
  name: "BeneficiaryBus",
  components: {
    CompanyDetails,
    AccountSection,
    Summary,
  },
  props: {
    cust_id: String,
    beneficiarybusData: {
      type: Object,
    },
  },

  data() {
    return {
      steps: [
        { text: this.$t("accountType") },
        { text: this.$t("basicDetails") },
        { text: this.$t("address") },
        { text: this.$t("bankDetails") },
      ],
      isTrans: "",
      currentStep: 1,
      loader: false,
      businessBeneData: {},
      beneficiaryReqBody: {
        full_name: "",
        id_no: "",
        nature_of_business: "",
        address: "",
        country_code: "",
        Remittee_country: "",
        state_code: "",
        Remittee_state: "",
        city_code: null,
        Remittee_city: "",
        postal_code: "",
        first_name: "",
        last_name: "",
        dob: null,
        designation: "",
        phone_number: "",
        email_id: "",
        payment_code: "B",
        currency_code: "",
        phone_number_cty_code: "",
        relationship_name:"",
        location_id: "",
        location_name: "",
        bank_name: "",
        branch_code: "",
        relationship_code:"",
        swift_no: "",
        bank_account_no: null,
      },
      bene_country_name: "",
      alertMsg: {
        status: false,
        text: "",
        timeout: 2000,
        color: "blue-grey",
        type: "info",
      },
      country_code: "",
    };
  },
  methods: {
    closeBusDialog() {
      this.$emit("closeBusDialog", false);
      this.$store.state.showDialog = false;
      this.currentStep = 1;
    },
    selctedCountry(val) {
      this.country_code = val;
    },
    onClickNext() {
      this.currentStep++;
      this.bene_country_name = this.beneficiaryReqBody.phone_number_cty_code;
      console.log("beneficiaryReqBody", this.beneficiaryReqBody);
    },
    onClickBack() {
      this.currentStep--;
    },
    async onCreateBeneficiary() {
      try {
        this.loader = true;
        let responseData;
        if (this.beneficiarybusData.receiver_id) {
          responseData = await remmitenceService.updateBusBenificiaryData(
            this.beneficiarybusData.receiver_id,
            this.beneficiaryReqBody
          );
        } else {
          responseData = await remmitenceService.saveBusBenificiaryData(
            this.$route.query.id,
            this.beneficiaryReqBody
          );
        }

        if (responseData && responseData.data.status_code == 200) {
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);
          this.$emit("closeBusDialog", false);
          this.$emit("getBenficiary");
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
        console.log(error);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
::v-deep ul {
  list-style-type: none !important;
}
::v-deep h4 {
  color: $txt;
  text-align: center;
}
.btn-light {
  font-weight: bold;
  color: $dimgrey;
  background: $white;
  margin: 0 5px;
  &:not(:disabled) {
    &:not(.disabled).active {
      color: $secondary;
    }
    &:not(.disabled) {
      &:active {
        color: $secondary;
      }
    }
  }
  &:hover {
    border: 1px solid red !important;
    color: $dimgrey;
    background: $white;
  }
}
.card {
  border: none;
}
::v-deep label {
  color: $lightslategrey !important;
  margin-bottom: 0 !important;
}
::v-deep .btn-light {
  border: 1px solid $lightgrey !important;
}
.color {
  background-color: $secondary;
}
.floating-placeholder-name {
  color: red;
  margin-top: -12px;
  font-size: 14px;
  text-align: -webkit-left;
}
.color-error {
  background-color: rgb(240, 50, 50);
}
</style>
